import React from "react";

export default function StatCard({ label, value, sub, icon: Icon, tone = "blue", testid }) {
  const tones = {
    blue: "bg-blue-50 text-brand-blue",
    green: "bg-emerald-50 text-brand-green",
    amber: "bg-amber-50 text-amber-600",
    slate: "bg-slate-100 text-slate-600",
  };
  return (
    <div className="sl-card p-5 sl-fade" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
          <div className="sl-stat-value mt-2">{value}</div>
          {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
        </div>
        {Icon && <div className={`w-10 h-10 rounded-lg grid place-items-center ${tones[tone]}`}><Icon size={18} /></div>}
      </div>
    </div>
  );
}
